import { Reducer } from '@reduxjs/toolkit';

const appUserReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { user: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, user: payload };
};

export default appUserReducer;
